var indentation_default = {
  "indentZero": "wmHkW",
  "indentOne": "r1pAQ",
  "indentTwo": "d8K9H",
  "indentThree": "ANTMY",
  "indentFour": "Z2eMG",
  "indentFive": "NhRpu",
  "indentSix": "VYvWn"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
